import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axios from 'axios';

import { QueryKeys } from 'src/constants/queryKeys';

import { getConfig } from '@app/config';
import { Base, Mode, ModeTestnet } from '@thirdweb-dev/chains';
import { useSupportedChain } from '@app/hooks/other/useSupportedChain';

type PoolsApr = Record<string, string>;

const fetcher = async (chainId: number | undefined) => {
  const config = getConfig(chainId);

  let network;

  switch (chainId) {
    case Mode.chainId: {
      network = 'mode';
      break;
    }
    case ModeTestnet.chainId: {
      network = 'mode-testnet';
      break;
    }
    case Base.chainId: {
      network = 'base';
      break;
    }
    default: {
      network = '';
    }
  }

  if (!network) {
    return null;
  }

  const { data } = await axios.get<PoolsApr>(
    `${config?.URLS.middlewareUrlV3}/APR/pools/?network=${network}`
  );

  return data;
};

export const usePoolsApr = (options: UseQueryOptions<PoolsApr | null> = {}) => {
  const chainId = useSupportedChain()?.chainId;

  return useQuery<PoolsApr | null>(
    [QueryKeys.POOLS_APR, chainId],
    async () => {
      return fetcher(chainId ?? Mode.chainId);
    },
    {
      staleTime: 10000,
      // enabled: !!chainId,
      ...options
    }
  );
};
